import { render, staticRenderFns } from "./japanese_curriculum.vue?vue&type=template&id=7be42e5f&scoped=true"
import script from "./japanese_curriculum.vue?vue&type=script&lang=js"
export * from "./japanese_curriculum.vue?vue&type=script&lang=js"
import style0 from "./japanese_curriculum.vue?vue&type=style&index=0&id=7be42e5f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be42e5f",
  null
  
)

export default component.exports